import {
  CollectionEntryOptions,
  createCollectionEntryExtension,
} from '@spotify/plugin-confidence-collections-react';

import { metricsPlugin } from '../plugin';

export const MetricCollectionEntryExtension = metricsPlugin.provide(
  createCollectionEntryExtension({
    id: 'metric',
    resourceType: 'Metric',
    predicate: ({ resource }: CollectionEntryOptions) =>
      '__typename' in resource && resource.__typename === 'MetricsV1Metric',
    render: () => null,
  }),
);
